import StudentAppFeeBlock from './StudentAppFeeBlock';
import { StudentAppFeeBlockProps, StudentAppFeeBlockValueProps } from './types';

export type { StudentAppFeeBlockProps, StudentAppFeeBlockValueProps };
export default StudentAppFeeBlock;
